import React from 'react'
import { sortByUid } from '../helpers.js'
import { Link, withPrefix } from 'gatsby'

const PaginatorNavigationRender = props => {
     props.arr.sort(sortByUid)
     const allItems = props.arr.map(element => {
          let uid = element.uid ? element.uid : element.node.uid
          let number = uid === 1 ? '' : '/' + uid
          let slug = props.baseSlug + number
          let thumbnail =
               'thumbnail/' + props.tilePrefix + uid + '-thumbnail.jpg'
          return (
               <div className="paginator__list__item" key={uid}>
                    <Link to={slug} activeClassName="current">
                         <div className="paginator__list__image">
                              <img src={withPrefix(thumbnail)} alt="" />
                         </div>
                         <span className="paginator__list__title">{uid}</span>
                    </Link>
               </div>
          )
     })
     return allItems
}

export default PaginatorNavigationRender
